import React, { Suspense, useContext } from "react";
import { Spin } from "antd";
import { AuthContext } from "contexts";
import { useAccess } from "contexts/access";
import { Navigate, useLocation } from "react-router-dom";

// Хамгаалалт: route.perm = [модуль, түвшин] бол баазын эрхээр (Эрх ба роль), эс бөгөөс хуучин role массиваар.
// perm: "any" — нэвтэрсэн бүх ажилтан.
const ProtectedRoute = (props) => {
  const { state } = useContext(AuthContext);
  const { can, loading } = useAccess();
  const location = useLocation();
  const { children, routeItem } = props;

  // Хуудсууд lazy (тусдаа chunk) тул Suspense; userInfo prop-ийг хуудсанд шууд дамжуулна
  const childrenWithProps = (
    <Suspense fallback={<div className="flex justify-center py-24"><Spin /></div>}>
      {React.Children.map(children, (child) => (React.isValidElement(child) ? React.cloneElement(child, { userInfo: state }) : child))}
    </Suspense>
  );

  if (!state.token && !state.loading) return <Navigate to="/login" state={{ from: location }} replace />;
  if (routeItem?.perm) {
    if (loading) return <div className="flex justify-center py-20"><Spin /></div>;
    if (routeItem.perm === "any" || can(...routeItem.perm)) return childrenWithProps;
    return location.pathname === "/" ? <div className="p-10 text-gray-500">Эрх тохируулаагүй байна — админд хандана уу.</div> : <Navigate to="/" replace />;
  }
  if (routeItem?.role?.includes(state.userInfo?.profile.role)) return childrenWithProps;
  return <Navigate to="/" state={{ from: location }} replace />;
};

export default ProtectedRoute;
